import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {discountInterface, discountSectionsInterface} from "./discounstInterface";
import {setDiscountSections} from "../../actions/priceWorksheetActions";
import DiscountCommon from "./discountCommon";
import {shouldUseMultipleWorkSheets} from "./discountFunctions";


class DiscountFinancedAmount extends DiscountCommon {

  static propTypes = {
    discount: PropTypes.shape(discountInterface),
    discountSection: PropTypes.shape(discountSectionsInterface),
  };

  render() {
    const {discount, financeActiveDiscount} = this.props;
    if (!financeActiveDiscount) {
      return null;
    }
    return (
      <li className={"discount discount--deposit"}>
        <div className="discount-cell discount-cell--name bold">{discount.name}</div>
        <div className="discount-cell discount-cell--special-amount">
          {this.renderAmountInput()}
        </div>
      </li>
    )
  }
}

const mapStateToProps = (store) => {
  const {discountSections, customAddedDiscounts, workSheetsCount, financeActiveDiscount} = store.priceWorksheetState;
  const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex, quotes} = store.quotesState;
  const {jobIsSaving} = store.serverState;

  return {
    discountSections,
    customAddedDiscounts,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
    fabricatorData: store.fabricatorState,
    fabricatorSettings: store.fabricatorState.settings,
    allWizardsValues,
    activeQuoteIndex,
    workSheetsCount,
    quotes,
    hasMultipleWorkSheets: shouldUseMultipleWorkSheets(workSheetsCount),
    jobIsSaving,
    financeActiveDiscount,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountFinancedAmount);
